module.exports = __webpack_public_path__ + "assets/51fba531932cbdadfe581b10dfc6a5e8.png";